import React from "react";
import axios from "axios";
import Cookies from "js-cookie";
import Flexbox from "flexbox-react";
import { inject, observer, Provider } from "mobx-react";
import ThemeWrapper from "../components/styles/ThemeWrapper/index.js";
import LayoutHeader from "../components/layout/LayoutHeader";
import ToastStore from "../stores/ToastStore";
import CurrentUserStore from "../stores/CurrentUserStore";

import ErrorBoundary from "../components/errors/ErrorBoundary";
import GoalSettingsCreateForm from "../components/goals/GoalSettingsCreateForm";
import GoalsFormList from "../components/goals/GoalsFormList.js";

@observer
export default class GoalSettingsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCreateForm: false,
      goals: [],
      loading: false,
      error: "",
    };
  }

  componentDidMount() {
    this.getAllGoals();
  }

  getAllGoals = () => {
    this.setState({ loading: true });
    return axios
      .get(`${Cookies.get("apiEnv")}/goal_settings`)
      .then(response => {
        this.setState({ goals: response.data, loading: false });
      })
      .catch(error => {
        this.setState({ error: "Failed to load goals", loading: false });
      });
  };

  handleAddGoalClick = () => {
    this.setState({ showCreateForm: true });
  };

  handleBackClick = () => {
    this.setState({ showCreateForm: false });
  };

  render() {
    const { showCreateForm, goals, loading, error } = this.state;
    const stores = { CurrentUserStore, ToastStore };

    return (
      <Provider {...stores}>
        <ThemeWrapper>
          <ErrorBoundary>
            <Flexbox flexGrow={1} width="100hw" alignContent="stretch" flexDirection="column" paddingBottom="0px">
              <Flexbox flexGrow={1} flexDirection="column" className="fixed-width-container" marginTop="20px">
                {!showCreateForm ? (
                  <GoalsFormList
                    goals={goals}
                    loading={loading}
                    error={error}
                    getAllGoals={this.getAllGoals}
                    onAddGoal={this.handleAddGoalClick}
                  />
                ) : (
                  <GoalSettingsCreateForm
                    onClose={this.handleBackClick}
                    getAllGoals={this.getAllGoals}
                  />
                )}
              </Flexbox>
            </Flexbox>
          </ErrorBoundary>
        </ThemeWrapper>
      </Provider>
    );
  }
}